// extracted by mini-css-extract-plugin
export var header = "_wn-1";
export var maskBottom = "_wn-6";
export var maskMiddle = "_wn-7";
export var maskTop = "_wn-5";
export var root = "_wn-0";
export var scrollDownButton = "_wn-3";
export var scrollDownButtonHidden = "_wn-4";
export var viewport = "_wn-2";